import { ActivationBanner } from "../../components/ActivationBanner"
import { SettingsNavLinks } from "../../components/SettingsNavLinks"
import { Card, SwitchAppButton } from "../../components"
import { OverflowMenu } from "@carbon/react"
import option from "../../assets/icons/option.svg"


export const View = () =>{
    const AccountPayout = ({bankname,currency,accountname})=>{
        return(
           
                <div className="bank-payout-content">
                    <div className="bankname-account-name">
                         <div className="bank-name">{bankname}</div> 
                        <strong><div className="account-name"> {accountname}</div></strong>
                     </div>
                        <div className="currency"> {currency}</div>
                        <div ><OverflowMenu /></div>
                </div>
    
           
        )
    
     }

 const Payoutsetting = ({status})=> {
    return(
      
            <div className="payout-settings-content">
                <input type="radio" />
                <p>{status}</p>
             </div>
    )
 }

    return(

        <>
            <SettingsNavLinks
      navtitle="Settings"
      navtitlelink="Bank accounts/currencies and payout settings"
      />
      <ActivationBanner 
            title="Please you need to activate your profile"
            subtitle="0ur guide will help you complete your Business profile and you’ll start receiving payments. Click this banner to complete your set-up."
            urlTarget="/onboarding"
      />
      <Card>
        <div className="bank-payout-header">
                <strong>Bank accounts/currencies</strong>
                 <SwitchAppButton
                className="bank-payout-success-btn"
                kind="success"  onClick={ () =>{("")} }            
                >Add bank account </SwitchAppButton>
        </div>
        <div className="bank-details-header">
            <strong className="bankname-header">Bank Name</strong>
            <strong className ="curency-header">Currency</strong>
        </div>
      <AccountPayout
       bankname="Guaranty Trust Bank"
       accountname = "OLUGBENGA PETER OLASUNKANMI"
       currency = "NGN"
      />
      <AccountPayout
       bankname="Access Bank"
       accountname = "OLUGBENGA PETER OLASUNKANMI"
       currency = "USD"
       />
       <div className="switchapp-small warning-option">
        <img src={option} alt="option-icon" />
        <p>Charges for currencies that have not been enabled will be 
            converted to your default currency, NGN.</p>
       </div>
      </Card>

      <Card>
        <div className = "payout-setting-header">
        <strong >Payout settings</strong>
        </div>
        <Payoutsetting
        status="Automatic every:"
        />
         <Payoutsetting
        status="Manual"
        />
      </Card>
        </>
    )
}
